// Styles
import '@mdi/font/css/materialdesignicons.css'
import 'vuetify/styles'

// Vuetify
import { createVuetify } from 'vuetify'
import lang from '@/lang'

export default createVuetify({
  locale: {
    locale: 'zhHant-HK',
    fallback: 'zhHant-HK',
    messages: { 'zhHant-HK': lang['zhHant-HK'], zhHant: lang.zhHant, zhHans: lang.zhHans, en: lang.en, ko: lang.ko, ja: lang.ja }
  }
})
// https://vuetifyjs.com/en/introduction/why-vuetify/#feature-guides
